import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookEditorModelResolverService = ( createDecorator('INotebookModelResolverService'));
export { INotebookEditorModelResolverService };
